/* pg-case-add */
(function(){
  if (window.pgCaseAdd) return; window.pgCaseAdd = 1;

  var PAID_VARIANT = 49640879063268;   /* $13.99 "Spare case" */
  var SEL = '.pg-case-add2, .pgx-case-add';
  var busy = false;

  /* Cosmetic only now -- the handler below matches either class, so a click
     that lands before this runs is still handled correctly. */
  function claim(){
    document.querySelectorAll('#pgx .pgx-case-add').forEach(function(btn){
      btn.classList.remove('pgx-case-add');
      btn.classList.add('pg-case-add2');
    });
  }

  function reset(btn, label, delay){
    setTimeout(function(){
      btn.textContent = label;
      btn.disabled = false;
      busy = false;
    }, delay);
  }

  /* capture on WINDOW: an ancestor's capture listener runs before document's,
     whoever registered first, so pg-mobile's dead-variant handler never sees
     this click */
  window.addEventListener('click', function(e){
    var btn = e.target && e.target.closest && e.target.closest(SEL);
    if (!btn) return;
    if (!btn.closest('#pgx')) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (busy) return;

    busy = true;
    btn.disabled = true;
    btn.textContent = 'ADDING...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({items: [{id: PAID_VARIANT, quantity: 1}]})
    })
      .then(function(r){
        if (!r.ok) throw new Error('add ' + r.status);
        btn.innerHTML = 'ADDED &#10003;';
        /* pgOpenCart appears exactly once in this theme -- here. Every other
           override that writes to the cart uses pgDrawerRefresh (pg-unlock,
           pg-no-promo, pg-cart-variants). If that name was wrong, or the drawer
           is not mounted on this template, nothing repainted after a SUCCESSFUL
           add: the button said ADDED, the header count did not move, and the
           shopper tapped again and again -- arriving at checkout with three
           cases they did not mean to buy. */
        if (window.pgDrawerRefresh) window.pgDrawerRefresh();
        else if (window.pgOpenCart) window.pgOpenCart();
        else window.location.reload();
        reset(btn, 'ADD', 2500);
      })
      .catch(function(){
        btn.textContent = 'TRY AGAIN';
        reset(btn, 'ADD', 2000);
      });
  }, true);

  /* pg-mobile re-creates the tile on an interval, so re-style on the same beat */
  setInterval(claim, 500);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', claim); else claim();
})();
